import { render, staticRenderFns } from "./mobFooter.vue?vue&type=template&id=2f7b717a&scoped=true"
import script from "./mobFooter.vue?vue&type=script&lang=js"
export * from "./mobFooter.vue?vue&type=script&lang=js"
import style0 from "./mobFooter.vue?vue&type=style&index=0&id=2f7b717a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7b717a",
  null
  
)

export default component.exports